import { File } from "../models/File";
import { clean } from "../utils/utils";
import api from "./api"; // your custom Axios instance

const PATH = "/api/v1/files";

export const FileService = {
  async createFile(
    file: globalThis.File, // The actual file object from the browser
    fileData: Omit<
      File,
      "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy"
    >,
  ): Promise<string> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", fileData.name);
    formData.append("type", fileData.type);
    formData.append("mimeType", file.type);
    formData.append("size", file.size.toString());
    if (fileData.matter) formData.append("matter", fileData.matter);
    if (fileData.intake) formData.append("intake", fileData.intake);
    if (fileData.folder) formData.append("folder", fileData.folder); // Append folder if provided
    if (fileData.task) formData.append("task", fileData.task);
    if (fileData.subtask) formData.append("subtask", fileData.subtask);
    if (fileData.discoveryRequest)
      formData.append("discoveryRequest", fileData.discoveryRequest);
    if (fileData.childSupportPayment)
      formData.append("childSupportPayment", fileData.childSupportPayment);
    if (fileData.spousalSupportPayment)
      formData.append("spousalSupportPayment", fileData.spousalSupportPayment);
    if (fileData.financialItem)
      formData.append("financialItem", fileData.financialItem);
    if (fileData.event) formData.append("event", fileData.event);
    if (fileData.participant)
      formData.append("participant", fileData.participant);
    if (fileData.description)
      formData.append("description", fileData.description);

    const res = await api.post(`${PATH}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data.data._id; // Return the ID of the created file
  },

  async getFile(fileId: string): Promise<File> {
    const response = await api.get(`${PATH}/${fileId}`);
    return response.data.data;
  },

  async getDownloadURL(fileId: string): Promise<string> {
    const response = await api.get(`${PATH}/${fileId}/download`);
    return response.data.data.url; // This should be the URL to download the file
  },

  async getFilesByMatter(matterId: string): Promise<File[]> {
    const response = await api.get(`${PATH}?matterId=${matterId}`);
    return response.data.data || [];
  },

  async updateFile(
    fileId: string,
    updatedData: Partial<Omit<File, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.patch(`${PATH}/${fileId}`, clean(updatedData));
  },

  async deleteFile(fileId: string): Promise<void> {
    await api.delete(`${PATH}/${fileId}`);
  },
};
